export const BOOK_DEMO_MODAL_OPEN_EVENT = 'hopeai:book-demo-modal:open'

export const emitOpenBookDemoModal = () => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(BOOK_DEMO_MODAL_OPEN_EVENT))
}

export const onOpenBookDemoModal = (handler: () => void) => {
  if (typeof window === 'undefined') return () => {}

  const listener = () => handler()
  window.addEventListener(BOOK_DEMO_MODAL_OPEN_EVENT, listener)
  return () => {
    window.removeEventListener(BOOK_DEMO_MODAL_OPEN_EVENT, listener)
  }
}
